/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AllShipmentsCarrierAnalytics
 */
export interface AllShipmentsCarrierAnalytics {
  /**
   *
   * @type {string}
   * @memberof AllShipmentsCarrierAnalytics
   */
  carrierIdentifier: string;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsCarrierAnalytics
   */
  quoteCount: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsCarrierAnalytics
   */
  winCount: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsCarrierAnalytics
   */
  winRate: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsCarrierAnalytics
   */
  avgPrice: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsCarrierAnalytics
   */
  totalRevenue: number;
}

/**
 * Check if a given object implements the AllShipmentsCarrierAnalytics interface.
 */
export function instanceOfAllShipmentsCarrierAnalytics(
  value: object,
): value is AllShipmentsCarrierAnalytics {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (!("quoteCount" in value) || value["quoteCount"] === undefined)
    return false;
  if (!("winCount" in value) || value["winCount"] === undefined) return false;
  if (!("winRate" in value) || value["winRate"] === undefined) return false;
  if (!("avgPrice" in value) || value["avgPrice"] === undefined) return false;
  if (!("totalRevenue" in value) || value["totalRevenue"] === undefined)
    return false;
  return true;
}

export function AllShipmentsCarrierAnalyticsFromJSON(
  json: any,
): AllShipmentsCarrierAnalytics {
  return AllShipmentsCarrierAnalyticsFromJSONTyped(json, false);
}

export function AllShipmentsCarrierAnalyticsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsCarrierAnalytics {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier: json["carrierIdentifier"],
    quoteCount: json["quoteCount"],
    winCount: json["winCount"],
    winRate: json["winRate"],
    avgPrice: json["avgPrice"],
    totalRevenue: json["totalRevenue"],
  };
}

export function AllShipmentsCarrierAnalyticsToJSON(
  json: any,
): AllShipmentsCarrierAnalytics {
  return AllShipmentsCarrierAnalyticsToJSONTyped(json, false);
}

export function AllShipmentsCarrierAnalyticsToJSONTyped(
  value?: AllShipmentsCarrierAnalytics | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    quoteCount: value["quoteCount"],
    winCount: value["winCount"],
    winRate: value["winRate"],
    avgPrice: value["avgPrice"],
    totalRevenue: value["totalRevenue"],
  };
}
